import { useState, useCallback } from "react";
import debounce from "lodash/debounce";
import { Get } from "react-axios";

import SearchFieldComponent from "./Search/Field/Field";
import SearchResponseComponent from "./Search/Response/Response";

function App(props) {
  const {
    tenant,
    input_debounce = 500,
    use_voice = true,
    customOptions,
  } = props;
  const options = { input_debounce, use_voice, customOptions, ...props };

  const apiUrl = `${process.env.REACT_APP_SEARCH_API_URL}/${tenant}/query`;

  const [searchParams, setSearchParams] = useState({ term: "" });
  const [activeQuery, setActiveQuery] = useState(false);
  const [action, setAction] = useState("text");

  const submitQuery = (input, useVoice = false) => {
    const action = useVoice ? "voice" : "text";
    setAction(action);

    if (!input || !input.length) return;

    setSearchParams({ term: input });
    setActiveQuery(true);

    // remove windows hash
    window.location.hash = "";
  };

  const handleInputChange = (input) => {
    inputDebounce(input);
  };

  const inputDebounce = useCallback(
    debounce((input) => {
      submitQuery(input);
    }, input_debounce),
    []
  );

  const clearSearch = () => {
    setActiveQuery(false);

    const url = new URL(window.location.href);
    url.searchParams.delete(options.keySearch || "pesquisa");
    window.history.replaceState(null, null, url);
  };

  return (
    <div className="App">
      <SearchFieldComponent
        options={options}
        onChange={handleInputChange}
        onSubmit={submitQuery}
        onClose={clearSearch}
      />

      {activeQuery ? (
        <Get
          url={apiUrl}
          params={searchParams}
          debounceImmediate={false}
          debounce={100}
          isReady={searchParams.term && searchParams.term.length > 0}
        >
          {(error, response, isLoading, makeRequest, axios) => (
            <SearchResponseComponent
              data={response && response.data}
              error={error}
              isLoading={isLoading}
              options={options}
              onClose={clearSearch}
              action={action}
            />
          )}
        </Get>
      ) : null}
    </div>
  );
}

export default App;
